module.exports = __webpack_public_path__ + "static/media/AutonomiQ Logo Shape.a24bd33f.svg";